export default __webpack_public_path__ + "static/media/logout.1eb6d758.svg";